import { Badge, Card, Group, Text } from "@mantine/core";
import type { Icon } from "@tabler/icons-react";

interface StatsCardProps {
	icon: Icon;
	title: string;
	value: string;
	description: string;
	color: string;
}

function StatsCard({
	icon: IconComponent,
	title,
	value,
	description,
	color,
}: StatsCardProps) {
	return (
		<Card
			shadow="sm"
			padding="lg"
			radius="md"
			withBorder>
			<Group
				justify="space-between"
				mb="xs">
				<IconComponent
					size={24}
					color={`var(--mantine-color-${color}-6)`}
				/>
				<Badge
					color={color}
					variant="light">
					Active
				</Badge>
			</Group>

			<Text
				fw={600}
				size="xl"
				mb="xs">
				{value}
			</Text>

			<Text
				size="sm"
				fw={500}
				mb="xs">
				{title}
			</Text>

			<Text
				size="xs"
				c="dimmed">
				{description}
			</Text>
		</Card>
	);
}

export default StatsCard;
